import { useEffect } from 'react';
import { useRoutes, Navigate, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';

// routes
import MainRoutes from './MainRoutes';
import AuthenticationRoutes from './AuthenticationRoutes';
import { rememberReturnTo } from 'utils/returnTo';

// Unauthenticated visit to a protected URL (e.g. a bookmarked
// /locations/168/dashboard): remember it so AuthLogin can send the user back
// once they have signed in.
const RedirectToLogin = () => {
  const { pathname, search, hash } = useLocation();

  useEffect(() => {
    rememberReturnTo(`${pathname}${search}${hash}`);
  }, [pathname, search, hash]);

  return <Navigate to="/login" replace />;
};

export default function ThemeRoutes() {
  const isLoggedIn = useSelector((state) => state.login.isLoggedIn);

  const routes = isLoggedIn
    ? [
        MainRoutes,
        AuthenticationRoutes,
        {
          path: '*',
          element: <Navigate to="/" replace />
        }
      ]
    : [
        AuthenticationRoutes,
        {
          path: '*',
          element: <RedirectToLogin />
        }
      ];

  return useRoutes(routes);
}
